import { cn } from "@/modules/lib/utils"
import { word } from "@modules/core/utils/i18n"
import { VIDEO_MAX_SIZE } from "@modules/ui/components/fileUpload/fileUploadUtils"
import { FileInputIcon } from "lucide-react"
import { Text } from "@/components/ui/baseUi/text"

export function MediaUploadDragZone({ disabled, className }: { disabled?: boolean; className?: string }) {
  return (
    <div
      className={cn(
        "group flex h-full flex-col items-center justify-center gap-2 transition-all duration-200 hover:bg-primary-100",
        !disabled && "cursor-pointer",
        className,
      )}
    >
      <div className="flex size-20 items-center justify-center rounded-full bg-surface-foreground transition-all duration-200 group-hover:bg-primary-500">
        <FileInputIcon
          color="currentColor"
          size={38}
          className="text-neutral-500 transition-all duration-200 group-hover:text-neutral-900"
        />
      </div>
      <Text
        fontStyle="BL"
        className="text-center text-neutral-500 transition-all duration-200 group-hover:text-neutral-900"
      >
        {word("sessionForm.blocks.add_media.drag_and_drop")}
      </Text>
      <Text
        fontStyle="BS"
        className="px-3 text-center whitespace-pre-line text-neutral-500 transition-all duration-200 group-hover:text-neutral-900"
      >
        {word("sessionForm.blocks.add_media.allowed_format", { max_size: VIDEO_MAX_SIZE / 1_000_000 })}
      </Text>
    </div>
  )
}
